import { Directive, ElementRef, HostListener } from '@angular/core';
import { isIE } from '../common/functions/common-helpers';

@Directive({
    selector: '[cpqBackToTop]',
    standalone: false
})

export class BackToTopDirective {
    private scrollContainer = document.body.querySelector('.setup-content');

    constructor(private el: ElementRef) { }

    @HostListener('click') scrollToTop() {
        if (isIE()) {
            this.scrollContainer.scrollTop = 0;
        } else { // other browsers
            this.scrollContainer.scroll({ top: 0, behavior: 'smooth' });
        }
    }
}
